const parse = (hex) => {
  const h = String(hex || "").replace("#", "");
  const full = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
  const n = parseInt(full, 16);
  return Number.isNaN(n) || full.length !== 6 ? null : [(n >> 16) & 255, (n >> 8) & 255, n & 255];
};

const hex = (rgb) => `#${rgb.map((v) => Math.round(Math.max(0, Math.min(255, v))).toString(16).padStart(2, "0")).join("")}`;

/** Mixes a colour toward black by `amount` (0–1). */
export const shade = (color, amount) => {
  const rgb = parse(color);
  return rgb ? hex(rgb.map((v) => v * (1 - amount))) : color;
};

/** Mixes a colour toward white by `amount` (0–1). */
export const tint = (color, amount) => {
  const rgb = parse(color);
  return rgb ? hex(rgb.map((v) => v + (255 - v) * amount)) : color;
};

export const alpha = (color, a) => {
  const rgb = parse(color);
  return rgb ? `rgba(${rgb.join(",")},${a})` : color;
};
